import { ChevronLeft, ChevronRight } from "lucide-react";

export const QueueNav = ({ nav }) => (
  <div className="queue-nav" data-testid="queue-nav">
    <button className="queue-btn" onClick={nav.onPrev} disabled={!nav.onPrev} data-testid="queue-prev-btn" aria-label="Previous artist">
      <ChevronLeft size={16} />
    </button>
    <span className="queue-pos" data-testid="queue-pos">
      {nav.index + 1} <span className="queue-sep">/</span> {nav.total}
      {nav.label && <span className="queue-label">{nav.label}</span>}
    </span>
    <button className="queue-btn" onClick={nav.onNext} disabled={!nav.onNext} data-testid="queue-next-btn" aria-label="Next artist">
      <ChevronRight size={16} />
    </button>
  </div>
);
